import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class EventSwiper {
  constructor() {
  }

  init() {
    this.initEventSwiper();
    this.setSwiperBlocksWidth();
    this.loadMoreBtn()
  }

  initEventSwiper() {
    const swiper = new Swiper('.swiper', {

      modules: [Navigation],
      loop: true,
      slidesPerView: "auto",
      freeMode: true,
      mousewheel: {
        releaseOnEdges: false,
      },
      breakpoints: {
        1440: {
          slidesPerView: "auto",
          spaceBetween: 46,
        },
        992: {
          slidesPerView: "2",
          spaceBetween: 30,
        },
        768: {
          slidesPerView: "auto",
          spaceBetween: 25,
        },
      },
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button_next',
        prevEl: '.swiper-button_prev',
      },
    });

    const swiperMobile = new Swiper('.swiper-mobile', {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: true,
      mousewheel: {
        releaseOnEdges: false,
      },
      speed: 1000,
    });
  }

  setSwiperBlocksWidth() {
    const swiper = $('.swiper');
    const slides =  swiper.find('.swiper-slide');
    const count = slides.length;

    switch (count) {
      case 1: 
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_one-slide');
        });
        break;
      case 2:
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_two-slides');
        });
        break;
      default:
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_three-slides');
        });
    }
  }

  loadMoreBtn() {
    $(document).ready(function () {
      $(".swiper-slide").each(function () {
          let $slide = $(this);
          let $infoBlock = $slide.find(".swiper-slide__item_info");
          let $button = $slide.find("button");
  
          $infoBlock.css({
              "max-height": "88px",
              "overflow": "hidden"
          });
  
          if ($infoBlock[0]?.scrollHeight > $infoBlock[0]?.clientHeight) {
              $infoBlock.addClass("truncated");
              $button.show(); 
          } else {
              $button.hide();
          }
  
          $button.on("click", function () {
              if ($slide.hasClass("expanded")) {
                  $slide.removeClass("expanded");
                  $infoBlock.css("max-height", "88px").addClass("truncated");
                  $(this).text("Подробнее");
              } else {
                  $slide.addClass("expanded");
                  $infoBlock.css("max-height", "none").removeClass("truncated");
                  $(this).text("Скрыть");
              }
          });
      });
    });
  }
}

let eventSwiper = new EventSwiper();
eventSwiper.init();